// v3.16.0 — Carte chat "Créer mon adresse" : AYA guide la création d'adresse
// directement dans la conversation (GPS → photo → nom via ClaimAddressWizard),
// puis affiche l'adresse PADA officielle + le code AYA obtenus.

import { useState } from "react";
import ClaimAddressWizard from "@/components/ClaimAddressWizard";

export default function AddressCreateCard({ data }) {
  const promptId = data?.prompt_id || "addr";
  const lsKey = `aya_addr_created_${promptId}`;
  const [wizardOpen, setWizardOpen] = useState(false);
  const [created, setCreated] = useState(() => {
    try { return JSON.parse(localStorage.getItem(lsKey) || "null"); } catch { return null; }
  });
  const isLogged = !!localStorage.getItem("civ_user_token");

  const onSuccess = (d) => {
    const rec = {
      friendly_name: d.friendly_name,
      address_civ: d.address_civ,
      commune_name: d.commune_name,
      pada: [d.quartier, d.street, d.house_number ? `n°${d.house_number}` : null, d.ilot ? `Îlot ${d.ilot}` : null, d.lot ? `Lot ${d.lot}` : null].filter(Boolean).join(", "),
    };
    setCreated(rec);
    try { localStorage.setItem(lsKey, JSON.stringify(rec)); } catch {}
  };

  const box = {
    marginTop: 10, borderRadius: 14, padding: "14px 16px",
    background: "linear-gradient(135deg, rgba(16,185,129,0.10), rgba(11,69,49,0.35))",
    border: "1px solid rgba(16,185,129,0.35)", color: "#F4F1E8",
  };

  if (created) {
    return (
      <div data-testid="address-create-success" style={box}>
        <div style={{ fontSize: 14, fontWeight: 800, marginBottom: 6 }}>🎉 Adresse créée : {created.friendly_name}</div>
        <div style={{
          display: "inline-block", fontFamily: "monospace", fontWeight: 800, fontSize: 13,
          background: "linear-gradient(135deg,#EFC75E,#D9A83C)", color: "#1A1206",
          borderRadius: 999, padding: "5px 14px", marginBottom: 8,
        }}>{created.address_civ}</div>
        <div style={{ fontSize: 12, opacity: 0.85 }}>
          🇨🇮 Adresse PADA : {created.pada || "en cours de résolution"} — {created.commune_name}
        </div>
        <div style={{ fontSize: 11.5, opacity: 0.6, marginTop: 6 }}>
          Retrouve-la dans Mon Compte → Adresses. Utilisable pour toutes tes livraisons.
        </div>
      </div>
    );
  }

  return (
    <div data-testid="address-create-card" style={box}>
      <div style={{ fontSize: 13.5, marginBottom: 10 }}>
        🏠 <strong>3 étapes</strong> : ta position GPS → une photo de ta devanture → un nom.
        Tu obtiens ton adresse officielle <strong>PADA 🇨🇮</strong> + ton <strong>code AYA</strong> doré.
      </div>
      {isLogged ? (
        <button
          type="button"
          data-testid="address-create-start-btn"
          onClick={() => setWizardOpen(true)}
          style={{
            width: "100%", borderRadius: 999, padding: "11px 0", border: "none", cursor: "pointer",
            background: "linear-gradient(135deg,#34D399,#10B981)", color: "#062A1F", fontWeight: 800, fontSize: 13.5,
          }}
        >📍 Créer mon adresse maintenant</button>
      ) : (
        <div data-testid="address-create-login-hint" style={{ fontSize: 12.5, color: "#FBBF24" }}>
          🔒 Connecte-toi d'abord (bouton Connexion en haut) pour créer ton adresse.
        </div>
      )}
      <ClaimAddressWizard open={wizardOpen} onClose={() => setWizardOpen(false)} onSuccess={onSuccess} />
    </div>
  );
}
